export const MEASURE_WEIGHTS_RESET_STATE = 'MEASURE_WEIGHTS_RESET_STATE';
export const MEASURE_WEIGHTS_CURRENT_ITEM = 'MEASURE_WEIGHTS_CURRENT_ITEM';

export const MEASURE_WEIGHTS_REQUEST_LOADING = 'MEASURE_WEIGHTS_REQUEST_LOADING';
export const MEASURE_WEIGHTS_REQUEST_SUCCESS = 'MEASURE_WEIGHTS_REQUEST_SUCCESS';
export const MEASURE_WEIGHTS_REQUEST_FAILED = 'MEASURE_WEIGHTS_REQUEST_FAILED';

export const MEASURE_WEIGHTS_CURRENT_ACTION = 'MEASURE_WEIGHTS_CURRENT_ACTION';
export const MEASURE_WEIGHTS_RESET_ACTION = 'MEASURE_WEIGHTS_RESET_ACTION';